export const getters = {
	myNews: state => {
		let result = []
		state.articles.forEach((article) => {
			if (resolveUserTags(article, state.userTags)) { result.push(article) }
		})
		return result
	},
	banqueNews: state => state.banques,
	allNews: state => state.articles,
	tags: state => state.tags,
	getArticle: state => id => {
		let result = null
		state.articles.forEach((article) => {
			if (parseInt(article.id) === parseInt(id)) {
				result = article
			}
		})

		if (!result) {
			state.banques.forEach((article) => {
				if (parseInt(article.id) === parseInt(id)) {
					result = article
				}
			})
		}

		return result
	},
	writtedNews: state => state.myNews
}

const resolveUserTags = (article, userTags) => {
	let shouldAdd = false
	article.news_tags.forEach((articleTag) => {
		// let isTag = false
		const idToCheck = (articleTag.tags) ? articleTag.tags.id : articleTag
		userTags.forEach((userTag) => {
			if (idToCheck === ((articleTag.tags) ? userTag.id : userTag.wordpress_tag_id)) {
				shouldAdd = true
			}
		})

		// if (!isTag) { shouldAdd = false }
	})

	return (article.news_tags.length > 0) ? shouldAdd : false
}



// WEBPACK FOOTER //
// ./src/common/store/News/getters.js